export const USE_TEST_RECAPTCHA = false

export const RECAPTCHA_TEST_SITE_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"

export const RECAPTCHA_SITE_KEY_PROD = "6LdGmswtAAAAAJfUwQXJCjMpvy55BEyYwf9-cUsL"

export const RECAPTCHA_SITE_KEY = USE_TEST_RECAPTCHA
  ? RECAPTCHA_TEST_SITE_KEY
  : RECAPTCHA_SITE_KEY_PROD

export const RECAPTCHA_SIZE = USE_TEST_RECAPTCHA ? "normal" : "invisible"

export const RECAPTCHA_ERROR_UA = "Не вдалося пройти перевірку reCAPTCHA. Оновіть сторінку та спробуйте ще раз."

export async function getRecaptchaToken(recaptchaRef) {
  const widget = recaptchaRef && recaptchaRef.current
  if (!widget) {
    return null
  }

  if (
    RECAPTCHA_SIZE === "invisible" &&
    typeof widget.executeAsync === "function"
  ) {
    return widget.executeAsync()
  }

  if (typeof widget.getValue === "function") {
    return widget.getValue() || null
  }

  return null
}

export function resetRecaptcha(recaptchaRef) {
  const widget = recaptchaRef && recaptchaRef.current
  if (widget && typeof widget.reset === "function") {
    widget.reset()
  }
}
